'use strict';

import Cleave from 'cleave.js';
import MCDatepicker from 'mc-datepicker';
import { Loading } from 'notiflix/build/notiflix-loading-aio';


//use requestAnimationFrame for smoothness (shimmed with setTimeout fallback)
window.requestAnimFrame = (function(){
    return  window.requestAnimationFrame       ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame    ||
        function( callback ){
            window.setTimeout(callback, 1000 / 60);
        };
})();

;(function($) {

    if (typeof $.fn.tooltip.Constructor === 'undefined') {
        throw new Error('Bootstrap Tooltip must be included first!');
    }

    var Tooltip = $.fn.tooltip.Constructor;

    // add customClass option to Bootstrap Tooltip
    $.extend( Tooltip.Default, {
        customClass: ''
    });

    var _show = Tooltip.prototype.show;

    Tooltip.prototype.show = function () {

        // invoke parent method
        _show.apply(this,Array.prototype.slice.apply(arguments));

        if ( this.config.customClass ) {
            var tip = this.getTipElement();
            $(tip).addClass(this.config.customClass);
        }

    };

})(window.jQuery);

//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//import ClassicEditor from '@custom-ckeditor/ckeditor';
//import ClassicEditor from './ckeditor5-classic';

//window.ClassicEditor = ClassicEditor;

// $("#myform").trackChanges();

//if ($("#myform").isChanged()) {
    // ...
//}
$.fn.extend({
    trackChanges: function(input, callback) {
        $(input,this).keyup(function() {
            $(this.form).data("changed", true);
            $(this.form).attr("data-changed", true);

            if (typeof callback !== 'undefined') {
                callback(this.form);
            }

            window.initialAddressChanged = true;
        });
    }
    ,
    isChanged: function() {
        return this.data("changed");
    }
});

$.fn.getDataAttributesAsJson = function () {
    var data = {};
    [].forEach.call(this.get(0).attributes, function (attr) {
        if (/^data-/.test(attr.name)) {
            var camelCaseName = attr.name.substr(5).replace(/-(.)/g, function ($0, $1) {
                return $1.toUpperCase();
            });
            data[camelCaseName] = attr.value;
        }
    });
    return data;
}

let isNumeric = function(num){
    return (typeof(num) === 'number' || typeof(num) === "string" && num.trim() !== '') && !isNaN(num);
}

let intervalID;

let processWidgetConfig = function(config) {

    let finalConfig = config;

    for (let i in finalConfig) {
        let key = i;
        let val = finalConfig[i];

        if( key === 'majorTicks' )
        {
            finalConfig[i] = finalConfig[i].split(',');
        }

        if( key === 'highlights' )
        {
            finalConfig[i] = JSON.parse(finalConfig[i]);
        }

        if (val === 'false') {
            finalConfig[i] = false;
        }

        if (val === 'true') {
            finalConfig[i] = true;
        }

        if( window.MyApp.helpers['isNumeric'](val) && key !== 'value' ) {
            finalConfig[i] = parseInt(finalConfig[i]);
        }
    }

    return finalConfig;
}

window.throttle = function(fn, wait) {
    var time = Date.now();

    return function() {
        if ((time + wait - Date.now()) < 0) {
            fn();
            time = Date.now();
        }
    }
}

window.LightTableFilter = (function (Arr) {
    let _input;

    function _onInputEvent(e) {
        _input = e.target;
        let tables = document.getElementsByClassName(_input.getAttribute('data-table'));
        Arr.forEach.call(tables, function (table) {
            Arr.forEach.call(table.tBodies, function (tbody) {
                let found = false; // Flag to track if any matching rows are found
                Arr.forEach.call(tbody.rows, function (row) {
                    let text = row.textContent.toLowerCase(),
                        val = _input.value.toLowerCase();
                    if (text.indexOf(val) === -1) {
                        row.style.display = 'none';
                    } else {
                        row.style.display = 'table-row';
                        found = true; // Matching row found
                    }
                });

                // Display "Nothing found" row if no matching rows are found
                if (!found) {
                    let nothingFoundRow = tbody.insertRow();
                    let cell = nothingFoundRow.insertCell();
                    cell.colSpan = table.rows[0].cells.length; // Set colspan to cover all columns
                    cell.style.textAlign = 'center'; // Center-align the text
                    cell.textContent = MyApp.getTrans("general.no_entries_found");
                }
            });
        });
    }

    return {
        init: function () {
            let inputs = document.getElementsByClassName('light-table-filter');
            Arr.forEach.call(inputs, function (input) {
                input.oninput = _onInputEvent;
            });
        }
    };
})(Array.prototype);


window.getByString = function (o, s) {
    s = s.replace(/\[(\w+)]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    let a = s.split('.');
    for (let i = 0, n = a.length; i < n; ++i) {
        let k = a[i];
        if (k in o) {
            o = o[k];
        } else {
            return;
        }
    }

    return o;
};

MyApp.getTrans = function (key, useLang=null) {
    if (typeof MyApp.translations === 'undefined') {
        return false;
    }

    let lang = document.documentElement.lang;

    if( useLang !== null ) {
        lang = useLang;
    }

    const obj = MyApp.translations[lang];

    return getByString(obj, key);
};

let general_js = {

    customToggleSections: function() {
        let closeAllSections = function() {
            $('.toggleSection').slideUp();
            $('.toggleIcon').removeClass('fa-angle-up').addClass('fa-angle-down');
        };

        $(document).on('click', '.toggleSectionHeadline', function(e) {
            e.preventDefault();
            //closeAllSections();

            let $that = $(this);
            let $icon = $that.find('.toggleIcon');
            let $wrapper = $that.parents('.toggleSectionWrapper').find('.toggleSection');

            $wrapper.slideToggle( "fast", function() {
                if ($icon.hasClass('fa-angle-down')) {
                    $icon.removeClass('fa-angle-down');
                    $icon.addClass('fa-angle-up')
                }
                else {
                    $icon.removeClass('fa-angle-up');
                    $icon.addClass('fa-angle-down')
                }
            });
        });
    },

    setCookie: function(name,value,days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    },

    getCookie: function(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    },

    eraseCookie: function(name) {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },

    cookieConsent: function() {
        let cookie = general_js.getCookie('allowCookies');
        if (cookie === null || typeof cookie === 'undefined' || cookie === false) {
            $('#cookieBanner').fadeIn('fast');
        }
    },

    preSelectTab: function () {
        let hash = window.location.hash;

        if (hash.length > 0 && $('ul.tabs-preselectable').length === 1) {
            $('ul.tabs-preselectable a[href="' + hash + '"]').tab('show');

            if( $(hash).length ) {
                $('html, body').animate({scrollTop: $(hash).offset().top - 200}, 200, function() {
                    //window.location.hash = hash;
                });
            }

        }
    },

    tabJumpToTop: function() {
        $('.nav-link[role="tab"]').on('click', function(event) {
            event.preventDefault();

            if (this.hash !== "") {
                let hash = this.hash;

                console.log(hash);

                $('html, body').animate({scrollTop: $('.tab-content').offset().top - 200}, 200, function() {
                    //window.location.hash = hash;
                });
            }
        });
    },

    fadeOut: function (el) {
        el.style.opacity = 1;

        (function fade() {
            if ((el.style.opacity -= .1) < 0) {
                el.style.display = "none";
            } else {
                requestAnimationFrame(fade);
            }
        })();
    },

    fadeIn: function (el, display) {
        el.style.opacity = 0;
        el.style.display = display || "block";

        (function fade() {
            let val = parseFloat(el.style.opacity);
            if (!((val += .1) > 1)) {
                el.style.opacity = val;
                requestAnimationFrame(fade);
            }
        })();
    },

    domElements: {
        sidebar_navigation: $('nav > ul.nav'),
        panelIconOpened: 'fal fa-arrow-up',
        panelIconClosed: 'fal fa-arrow-down',
    },

    siteSettings: {
        colors: {},
        ajaxLoad: false
    },

    aosInit: function () {
        AOS.init({
            disable: 'mobile',
            once: true
        });
    },

    flashAlert: function () {
        $('body').find('.flash-message').not('.alert-important').delay(4000).slideUp(350);
    },

    initSiteSettings: function () {
        //Default colours
        general_js.siteSettings.colors.brandPrimary = '#20a8d8';
        general_js.siteSettings.colors.brandSuccess = '#4dbd74';
        general_js.siteSettings.colors.brandInfo = '#63c2de';
        general_js.siteSettings.colors.brandWarning = '#f8cb00';
        general_js.siteSettings.colors.brandDanger = '#f86c6b';

        general_js.siteSettings.colors.grayDark = '#2a2c36';
        general_js.siteSettings.colors.gray = '#55595c';
        general_js.siteSettings.colors.grayLight = '#818a91';
        general_js.siteSettings.colors.grayLighter = '#d1d4d7';
        general_js.siteSettings.colors.grayLightest = '#f8f9fa';
    },
    createDynamicLabelDropDown: function($element, type) {
        let newTag = null;
        let tagCreated = false;

        let select = $element.select2({
            tags: true,
            multiple: true,
            tokenSeparators: [','],
            theme: 'default',
            formatNoMatches: MyApp.getTrans('general.no_entries_found'),
            language: {
                noResults: function (params) {
                    return MyApp.getTrans('general.no_entries_found');
                }
            },
            insertTag: function(data, tag) {
                if (tag.text.length < 1) {
                    newTag = null;
                    tagCreated = false;
                    return null;
                }

                if (tag.text === '') {
                    newTag = null;
                    tagCreated = false;
                    return null;
                }

                newTag = tag;
                tagCreated = true;

                return null;
            },
        });

        $element.off('select2:open').on('select2:open', function() {
            let $searchField = $element.data('select2').dropdown.$search || $element.data('select2').selection.$search;

            $searchField.off('keydown').on('keydown', function(e) {

                if (newTag !== null && tagCreated && e.keyCode === 13) {
                    let term = $.trim(newTag.text);
                    let id = term;

                    if (term.length < 1) {
                        newTag = null;
                        tagCreated = false;
                        return null;
                    }

                    if (term === '') {
                        newTag = null;
                        tagCreated = false;
                        return null;
                    }

                    let $select2Container = $element.data('select2').$container;
                    $select2Container.addClass('select2-container--disabled');
                    $element.prop('disabled', true);

                    $.ajaxSetup({headers: {'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content}});

                    return $.ajax({
                        type: "POST",
                        url: window.MyApp.routes['space.label.quick-add'],
                        data: {term: term, type: type},
                    }).then(function(response) {
                        id = response.label.id;
                        window.Notifier.success(response.successTitle);

                        let newOption = new Option(term, id, false, true);
                        $element.append(newOption).trigger('change');

                        data.push(newTag);
                        newTag = null;
                        tagCreated = false;

                        $select2Container.removeClass('select2-container--disabled');
                        $element.prop('disabled', false);

                        return null;
                    }).fail(function(xhr, status, error) {
                        $element.prop('disabled', false);

                        newTag = null;
                        tagCreated = false;

                        $select2Container.removeClass('select2-container--disabled');
                        $element.prop('disabled', false);

                        return null;
                    });
                }
            });
        });
    },
    select2: function () {
        $(document).find(".select2").select2({
            theme: 'default',
            formatNoMatches: MyApp.getTrans('general.no_entries_found'),
            escapeMarkup: function (markup) {
                return markup;
            },
            language: {
                noResults: function (params) {
                    return MyApp.getTrans('general.no_entries_found');
                }
            },
            templateSelection : function (tag, container){
                // here we are finding option element of tag and
                // if it has property 'locked' we will add class 'locked-tag'
                // to be able to style element in select
                let $option = $('.select2 option[value="'+tag.id+'"]');
                if ($option.attr('locked')){
                    $(container).addClass('locked-tag');
                    tag.locked = true;
                }
                return tag.text;
            },
        }).on('select2:unselecting', function(e){
            // before removing tag we check option element of tag and
            // if it has property 'locked' we will create error to prevent all select2 functionality
            if ($(e.params.args.data.element).attr('locked')) {
                return false;
            }
        });

        $(document).on('select2:opening.disabled', ':disabled', function () {
            return false;
        });

        /*
        $(document).find(".select2").on('select2:select', function (e) {
            $(this).focus();
        });

        $(document).on('focus', '.select2-selection.select2-selection--single', function (e) {
            $(this).closest(".select2-container").siblings('select:enabled').select2('open');
        })

        $(".form-control.select-search").on('select2:closing', function (e) {
            $(e.target).data("select2").$selection.one('focus focusin', function (e) {
                e.stopPropagation();
            });
        });
         */

        $(document).on('select2:open', function(e) {

            let idOrName = e.target.id;

            if(idOrName === '') {
                idOrName = e.target.name;
            }

            if(typeof idOrName !== 'undefined') {
                idOrName = idOrName.replace(/^[^a-z]+|[^\w:.-]+/gi, "");

                let selector = `[aria-controls="select2-${idOrName}-results"]`;

                let elem = document.querySelector(selector);

                if(elem !== null) {
                    elem.focus();
                }

                /*
                let elem = $(e.target).find('.select2-search__field');

                console.log(e.target);
                console.log(e);

                if(elem !== null) {
                    elem.focus();
                }
                 */
            }
        });
    },

    resizeSelect2: function () {
        $(".select2").each(function () {
            $(this).attr('style', 'width: 100%');
        });
    },

    confirmAction: function () {
        $(document).on('click', '.confirm-action:not(.disabled)', function (e) {
            e.preventDefault();

            let redirect = '';
            let that = $(this);

            if ($(this).attr('href')) {
                redirect = $(this).attr('href');
            }

            Prompter.init({
                title: $(that).attr('data-title') ? $(that).attr('data-title') : MyApp.trans.modal.confirm.title,
                content: $(that).attr('data-content') ? $(that).attr('data-content') : MyApp.trans.modal.confirm.body.text,
            }, function() {
                window.MyApp.helpers.showLoader();

                if (redirect !== '') {
                    window.location = redirect;
                } else {
                    that.parents('form').submit();
                }
            });
        });
    },

    isFunction: function (obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    },

    customAjaxForm: function (form, config) {
        $('body').on('submit', form, function (e) {
            e.preventDefault();

            general_js.showLoader();

            if (typeof (CKEDITOR) !== "undefined") {
                let instance;
                for (instance in CKEDITOR.instances) {
                    if (CKEDITOR.instances.hasOwnProperty(instance)) {
                        CKEDITOR.instances[instance].updateElement();
                    }
                }
            }

            let form = $(this);
            let formData = form.serializeJSON();
            let formResult = form.find('.form-result');
            let formMethod = form.attr('method');
            let submitButton = form.find('[type="submit"]');

            let method = $('_method');

            if (method.length) {
                formMethod = method.val()
            }

            $.ajaxSetup({headers: {'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content}});

            $('.invalid-feedback').slideUp().remove();
            $('.form-group').removeClass('is-invalid');
            $('.input-group').removeClass('is-invalid');
            $('.cke').removeClass('is-invalid');
            $('input, select').removeClass('is-invalid');
            $('input, select, .select2-selection').removeClass('is-invalid-select2');

            submitButton.attr('disabled', '');

            let request = $.ajax({
                type: formMethod,
                dataType: 'json',
                url: form.attr('action'),
                data: formData,
            });


            request.done(function (data) {

                if (data.hasOwnProperty('success') && data.success === true) {

                    if (config !== undefined && config.hasOwnProperty('successCallback') && general_js.isFunction(config.successCallback)) {
                        config.successCallback(data, formData);
                    }

                    let successTitle = data.hasOwnProperty('successTitle') ? data.successTitle : MyApp.trans.form.success_update_title;

                    formResult
                        .removeClass('open-alert')
                        .removeClass('bg-danger')
                        .removeClass('bg-success')
                        .addClass('bg-success')
                        .slideDown()
                        .html('<h2 style="margin: 0; color: #fff;"><i class="fa fa-save"></i> ' + successTitle + '</h2>');


                    let resetAfterSubmitTime = 4000;
                    if (data.hasOwnProperty('resetAfterSubmitTime')) {
                        resetAfterSubmitTime = data.resetAfterSubmitTime;
                    }

                    setTimeout(function () {
                        formResult
                            .slideUp()
                            .removeClass('open-alert')
                            .removeClass('bg-danger')
                            .removeClass('bg-success')
                            .html('');

                        if (form.hasClass('resetAfterSubmit') || data.hasOwnProperty('resetAfterSubmit') && data.resetAfterSubmit === true) {
                            form.trigger("reset");
                            form[0].reset();
                        }

                    }, resetAfterSubmitTime);


                    //$('html, body').animate({scrollTop: form.find('.form-result').offset().top - 300}, 1000);

                    if (data.hasOwnProperty('redirect')) {
                        let redirectTime = 3000;

                        if (data.hasOwnProperty('redirectTime')) {
                            redirectTime = data.redirectTime;
                        }

                        setTimeout(function () {
                            general_js.hideLoader();
                            window.location = data.redirect;
                        }, redirectTime);
                    }
                    else {
                        general_js.hideLoader();
                    }
                } else {
                    if (config !== undefined && config.hasOwnProperty('errorCallback') && general_js.isFunction(config.errorCallback)) {
                        config.errorCallback(data);
                    }
                }

                submitButton.removeAttr('disabled');
            });

            request.fail(function (jqXHR, textStatus, error) {
                let errors = jqXHR.responseJSON;

                if (config !== undefined && config.hasOwnProperty('errorCallback') && general_js.isFunction(config.errorCallback)) {
                    config.errorCallback();
                }

                if (errors.hasOwnProperty('custom_error')) {
                    $.each(errors, function (i, v) {
                        let msg = '<span class="invalid-feedback"><strong>' + v + '</strong></span>';

                        if (i.split('.').length === 2) {
                            let partials = i.split('.');
                            i = partials[0] + '[' + partials[1] + ']';
                        }

                        if (i.split('.').length >= 3) {
                            let partials = i.split('.');
                            i = partials[0] + '[' + partials[1] + ']' + '[' + partials[2] + ']';
                        }

                        let defaultInput = $('input[name="' + i + '"], textarea[name="' + i + '"]');

                        if (defaultInput.hasClass('custom-ckeditor')) {
                            defaultInput
                                .addClass('is-invalid')
                                .parent('.form-group')
                                .addClass('is-invalid').find('.cke').addClass('is-invalid').after(msg);
                        }

                        if (defaultInput.parent('.form-group').length && !defaultInput.hasClass('custom-ckeditor')) {
                            defaultInput
                                .after(msg)
                                .addClass('is-invalid')
                                .parent('.form-group')
                                .addClass('is-invalid');
                        }


                        if (defaultInput.parent('.input-group').length) {
                            defaultInput
                                .addClass('is-invalid')
                                .parent('.input-group')
                                .addClass('is-invalid')
                                .after(msg);
                        }


                        let selectInputMultiple = $('select[name="' + i + '[]"]');

                        if (selectInputMultiple.hasClass('select2')
                        ) {
                            selectInputMultiple
                                .addClass('is-invalid')
                                .parent('.form-group')
                                .addClass('is-invalid')
                                .find('.select2-container')
                                .after(msg);

                            selectInputMultiple
                                .parent('.form-group')
                                .find('.select2-selection')
                                .addClass('is-invalid-select2');
                        }

                        let selectInputDefault = $('select[name="' + i + '"]');

                        if (selectInputDefault.hasClass('select2')
                        ) {
                            selectInputDefault
                                .addClass('is-invalid')
                                .parent('.form-group')
                                .addClass('is-invalid')
                                .find('.select2-container')
                                .after(msg);

                            selectInputDefault
                                .parent('.form-group')
                                .find('.select2-selection')
                                .addClass('is-invalid-select2');
                        }
                    });

                    let keys = Object.keys(errors);
                    let set_focus = $('input[name="' + keys[0] + '"], select[name="' + keys[0] + '"], textarea[name="' + keys[0] + '"]');

                    let custom_error = '<h2 style="margin: 0;">' + MyApp.trans.form.error_title + '</h2>' +
                        '<p style="margin-bottom: 0;">' + MyApp.trans.form.error_text + '</p>';


                    if (errors.hasOwnProperty('custom_error')) {
                        custom_error = '<h2 style="margin: 0;">' + errors.custom_error.errorTitle + '</h2>' +
                            '<p style="margin-bottom: 0;">' + errors.custom_error.errorMessage + '</p>';
                    }

                    formResult
                        .addClass('open-alert')
                        .addClass('alert-important')
                        .addClass('bg-danger')
                        .slideDown()
                        .html(custom_error);

                    /*
                    $('html, body').animate({scrollTop: form.find('.form-result').offset().top}, 1000, function () {
                        set_focus.focus()
                    });
                    */
                    set_focus.focus()

                }
                submitButton.removeAttr('disabled');
                general_js.hideLoader();
            });

            submitButton.removeAttr('disabled');
            general_js.hideLoader();
        });
    },

    ajaxForm: function () {
        FormValidator.init('form.ajax-form', {

        });
    },

    onReadyHelper: function(callback, timeout) {
        setTimeout( function(){
            //$('.loadingText').hide();
            //$('#loadingText1').show();

            Loading.change($('#loadingText1').length ? $('#loadingText1').text() : '');
        } , 500);
        setTimeout( function(){
            //$('.loadingText').hide();
            //$('#loadingText2').show();
            Loading.change($('#loadingText2').length ? $('#loadingText2').text() : '');
        }, 5000);

        setTimeout( function(){
            //$('.loadingText').hide();
            //('#loadingText3').show();
            Loading.change($('#loadingText3').length ? $('#loadingText3').text() : '');
        }, 15000);

        setTimeout( function(){
            //$('.loadingText').hide();
            //$('#loadingText4').show();
            Loading.change($('#loadingText4').length ? $('#loadingText4').text() : '');
        }, 30000);

        intervalID = window.setInterval(checkReady, timeout);

        function checkReady() {
            if (document.getElementsByTagName('body')[0] !== undefined) {
                window.clearInterval(intervalID);
                callback.call(this);
            }
        }
    },

    showLoader: function () {
        general_js.onReadyHelper(function () {
            Loading.standard($('#loadingText1').text(), {backgroundColor: 'rgba(28, 41, 57, 0.95)'});
            $('body').addClass('lock-body');

            //$('#widget-loader').css({display: 'flex'}).fadeIn();
        }, 0);
    },

    hideLoader: function () {
        //$('.loadingText').hide();
        window.clearInterval(intervalID);
        $('body').removeClass('lock-body');
        Loading.remove();
        //$('#widget-loader').fadeOut();
    },

    allowNumericWithoutDecimal: function () {
        $(document).on("keypress keyup blur", ".allownumericwithoutdecimal",function (event) {
            $(this).val($(this).val().replace(/[^\d].+/, ""));
            if ((event.which < 48 || event.which > 57) && event.which !== 8) {
                event.preventDefault();
            }
        });
    },

    allowNumericWithDecimal: function () {
        function testInput(inputValue)
        {

            if (inputValue.match(/^-?[+]?[0-9]+([.][0-9]{1,2})?$/)){
                return 1;
            }
            else if(inputValue.match(/^-?[+]?[0-9]+([.])?$/)){
                return 1;
            }
            else{
                return 0;
            }

        }

        $(document).on("keypress keyup blur", ".allownumericwithdecimal", function (event) {
            let val = $(this).val();
            if(val.length == 1 && val == '-'){
                //do nothing
            }
            else{
                let retValu = testInput(val);

                if(retValu != '1'){
                    try{
                        val = val.substring(0, val.length - 1);
                        $(this).val(val);
                        //$(this).putCursorAtEnd();
                    }catch(e){

                    }
                }
            }
        });
    },

    tooltip: function () {
        /*
        $(document).find('[data-toggle="tooltip"]').tooltip({
            container: 'body'
        });
        */

        $('body').tooltip({
            boundary: 'window',
            selector: '[data-toggle="tooltip"]',
            trigger: 'hover',
            /*
            template: '<div class="tooltip custom-tooltip '+$(this).data('custom-css')+'" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
            title: function () {
                return $(this).attr('title');
            },
            customClass: function () {
                return $(this).data('custom-css');
            }
             */
        });
    },

    tablesorter: function () {
        if ( typeof $.fn.tablesorter === 'function' ) {
            $(".tablesorter").tablesorter();
        }
    },

    disableLinks: function () {
        $(document).on('click', 'a', function (event) {
            if ($(this).hasClass("disabled")) {
                event.preventDefault();
            }
        });
    },

    matchHeightInit: function () {
        if ( typeof $.fn.matchHeight === 'function' ) {
            $('.eq-height').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });
        }
    },

    mainNavigation: function (e) {
        let nav = $('nav > ul.nav');
        nav.find('a').each(function () {

            let cUrl = String(window.location).split('?')[0];

            if (cUrl.substr(cUrl.length - 1) === '#') {
                cUrl = cUrl.slice(0, -1);
            }

            if ($($(this))[0].href === cUrl) {
                $(this).addClass('active');

                $(this).parents('ul').add(this).each(function () {
                    $(this).parent().addClass('open');
                });
            }
        });

        nav.on('click', 'a', function (e) {
            if (general_js.siteSettings.ajaxLoad) {
                e.preventDefault();
            }

            if ($(this).hasClass('nav-dropdown-toggle')) {
                $(this).parent().toggleClass('open');
                general_js.resizeBroadcast()
            }
        });
    },

    resizeBroadcast: function () {

        let timesRun = 0;
        let interval = setInterval(function () {
            timesRun += 1;
            if (timesRun === 5) {
                clearInterval(interval);
            }
            window.dispatchEvent(new Event('resize'));
        }, 62.5);
    },

    disableMovingToTop: function () {
        $('a[href="#"][data-top!=true]').click(function (e) {
            e.preventDefault();
        });
    },

    cardActions: function () {
        $('.card-actions').on('click', 'a, button', function (e) {
            e.preventDefault();

            if ($(this).hasClass('btn-close')) {
                $(this).parent().parent().parent().fadeOut();
            } else if ($(this).hasClass('btn-minimize')) {
                if ($(this).hasClass('collapsed')) {
                    $('i', $(this)).removeClass(general_js.domElements.panelIconOpened).addClass(general_js.domElements.panelIconClosed);
                } else {
                    $('i', $(this)).removeClass(general_js.domElements.panelIconClosed).addClass(general_js.domElements.panelIconOpened);
                }
            } else if ($(this).hasClass('btn-setting')) {
                $('#myModal').modal('show');
            }

        });
    },

    sidebarToggleSetting: function () {

        $('.site_setting_sidebar_toggle').on('click', function () {
            let old_setting_value = $(this).data('setting-value');
            let new_setting_value = old_setting_value === 1 ? 0 : 1;
            let $this = $(this);

            $.ajaxSetup({headers: {'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content}});

            let request = $.ajax({
                type: 'post',
                dataType: 'json',
                url: route('space.set-sidebar-toggle-setting'),
                data: {setting_value: new_setting_value}
            });

            request.done(function (response) {
                if (response.success) {
                    $this.attr('data-setting-value', new_setting_value);
                    $this.data('setting-value', new_setting_value);

                    if (typeof window.LaravelDataTables !== "undefined") {
                        Laravel.helpers['redrawDatatableToFullwidth']();
                        window.LaravelDataTables['dataTableBuilder'].columns.adjust().draw();
                        window.LaravelDataTables['dataTableBuilder'].state.save();
                    }
                }
            });

            request.fail(function (jqXHR, textStatus, error) {
                //
            });
        });
    },

    sidebarMinimizerSetting: function () {

        $('.sidebar-minimizer').on('click', function () {
            let old_setting_value = $(this).data('setting-value');
            let new_setting_value = old_setting_value === 1 ? 0 : 1;
            let $this = $(this);

            $.ajaxSetup({headers: {'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content}});

            let request = $.ajax({
                type: 'post',
                dataType: 'json',
                url: route('space.set-sidebar-minimizer-setting'),
                data: {setting_value: new_setting_value}
            });

            request.done(function (response) {
                if (response.success) {
                    $this.attr('data-setting-value', new_setting_value);
                    $this.data('setting-value', new_setting_value);

                    if (typeof window.LaravelDataTables !== "undefined") {
                        Laravel.helpers['redrawDatatableToFullwidth']();
                        window.LaravelDataTables['dataTableBuilder'].columns.adjust().draw();
                        window.LaravelDataTables['dataTableBuilder'].state.save();
                    }

                }
            });

            request.fail(function (jqXHR, textStatus, error) {
                //
            });
        });
    },

    asideToggleSetting: function () {

        $('.aside-menu-toggler').on('click', function () {
            let old_setting_value = $(this).data('setting-value');
            let new_setting_value = old_setting_value === 1 ? 0 : 1;
            let $this = $(this);

            $.ajaxSetup({headers: {'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content}});

            let request = $.ajax({
                type: 'post',
                dataType: 'json',
                url: route('space.set-aside-toggle-setting'),
                data: {setting_value: new_setting_value}
            });

            request.done(function (response) {
                if (response.success) {
                    $this.attr('data-setting-value', new_setting_value);
                    $this.data('setting-value', new_setting_value);

                    if (typeof window.LaravelDataTables !== "undefined") {
                        Laravel.helpers['redrawDatatableToFullwidth']();
                        window.LaravelDataTables['dataTableBuilder'].columns.adjust().draw();
                        window.LaravelDataTables['dataTableBuilder'].state.save();
                    }
                }
            });

            request.fail(function (jqXHR, textStatus, error) {
                //
            });
        });
    },

    checkRowDelete: function () {
        $(document).on('change', '.check_row_delete', function () {
            let $this = $(this);
            let $delete_row_button = $('#delete_row_button');

            if ($this.prop('checked')) {
                $this.prop('checked', true);
                //$delete_row_button.fadeIn();
                $delete_row_button.removeClass('disabled');
            } else {
                $this.prop('checked', false);
                //$delete_row_button.fadeOut();
                $delete_row_button.addClass('disabled');
            }
        });


        $('body').on('change', '#check_all_rows', function () {

            let $this = $(this);
            let $checkRowDelete = $('body').find('.check_row_delete');
            let $deleteRowButton = $(document).find('.datatableLabelWrapper .delete_row_button');

            let checkbox_count = parseInt($checkRowDelete.length);

            if (checkbox_count > 0) {
                $deleteRowButton.fadeIn();
            }

            if ($this.prop('checked')) {
                $checkRowDelete.prop('checked', true);
                $deleteRowButton.removeClass('disabled');
            } else {
                $checkRowDelete.prop('checked', false);
                $deleteRowButton.addClass('disabled');
            }
        });
    },

    tabHashNavigation: function () {
        $('.nav-tabs a').click(function (e) {
            //$(this).tab('show');
            window.location.hash = this.hash;
        });
    },

    redrawDatatableToFullwidth: function () {
        $('#dataTableBuilder').css('width', '100%');
        window.LaravelDataTables['dataTableBuilder'].state.save();
        console.log('Table redrawn');
    },

    generateSlug: function (input) {
        let result = input;

        result = result.replace(/ /g, "-").toLowerCase();
        result = result.replace(/[^a-zA-ZäöüÄÖÜß0-9-\s]/, '');
        result = result.replace(/-+/g, '-');
        result = result.replace(/_+/g, '-');

        result = general_js.replaceUmlauts(result);

        return result;
    },

    inputSlugListener: function () {
        $('#app').on('keypress keyup blur paste', '.input-slug', function () {
            let currentVal = $(this).val();
            $(this).val(general_js.generateSlug(currentVal));
        });
    },

    replaceUmlauts: function (input) {
        let diacriticsMap = [
            {
                'base': 'A',
                'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
            },
            {'base': 'AA', 'letters': /[\uA732]/g},
            {'base': 'AE', 'letters': /[\u00C4\u00C6\u01FC\u01E2]/g},
            {'base': 'AO', 'letters': /[\uA734]/g},
            {'base': 'AU', 'letters': /[\uA736]/g},
            {'base': 'AV', 'letters': /[\uA738\uA73A]/g},
            {'base': 'AY', 'letters': /[\uA73C]/g},
            {'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g},
            {'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g},
            {'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g},
            {'base': 'DZ', 'letters': /[\u01F1\u01C4]/g},
            {'base': 'Dz', 'letters': /[\u01F2\u01C5]/g},
            {
                'base': 'E',
                'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
            },
            {'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g},
            {'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g},
            {'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g},
            {
                'base': 'I',
                'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
            },
            {'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g},
            {'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g},
            {
                'base': 'L',
                'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
            },
            {'base': 'LJ', 'letters': /[\u01C7]/g},
            {'base': 'Lj', 'letters': /[\u01C8]/g},
            {'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g},
            {'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g},
            {'base': 'NJ', 'letters': /[\u01CA]/g},
            {'base': 'Nj', 'letters': /[\u01CB]/g},
            {
                'base': 'O',
                'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
            },
            {'base': 'OE', 'letters': /[\u00D6\u0152]/g},
            {'base': 'OI', 'letters': /[\u01A2]/g},
            {'base': 'OO', 'letters': /[\uA74E]/g},
            {'base': 'OU', 'letters': /[\u0222]/g},
            {'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g},
            {'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g},
            {'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g},
            {'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g},
            {'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g},
            {'base': 'TZ', 'letters': /[\uA728]/g},
            {
                'base': 'U',
                'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
            },
            {'base': 'UE', 'letters': /[\u00DC]/g},
            {'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g},
            {'base': 'VY', 'letters': /[\uA760]/g},
            {'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g},
            {'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g},
            {'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g},
            {'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g},
            {
                'base': 'a',
                'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
            },
            {'base': 'aa', 'letters': /[\uA733]/g},
            {'base': 'ae', 'letters': /[\u00E4\u00E6\u01FD\u01E3]/g},
            {'base': 'ao', 'letters': /[\uA735]/g},
            {'base': 'au', 'letters': /[\uA737]/g},
            {'base': 'av', 'letters': /[\uA739\uA73B]/g},
            {'base': 'ay', 'letters': /[\uA73D]/g},
            {'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g},
            {'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g},
            {'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g},
            {'base': 'dz', 'letters': /[\u01F3\u01C6]/g},
            {
                'base': 'e',
                'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
            },
            {'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g},
            {'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g},
            {'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g},
            {'base': 'hv', 'letters': /[\u0195]/g},
            {
                'base': 'i',
                'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
            },
            {'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g},
            {'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g},
            {
                'base': 'l',
                'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
            },
            {'base': 'lj', 'letters': /[\u01C9]/g},
            {'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g},
            {'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g},
            {'base': 'nj', 'letters': /[\u01CC]/g},
            {
                'base': 'o',
                'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
            },
            {'base': 'oe', 'letters': /[\u00F6\u0153]/g},
            {'base': 'oi', 'letters': /[\u01A3]/g},
            {'base': 'ou', 'letters': /[\u0223]/g},
            {'base': 'oo', 'letters': /[\uA74F]/g},
            {'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g},
            {'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g},
            {'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g},
            {'base': 's', 'letters': /[\u0073\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g},
            {'base': 'ss', 'letters': /[\u00DF]/g},
            {'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g},
            {'base': 'tz', 'letters': /[\uA729]/g},
            {
                'base': 'u',
                'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
            },
            {'base': 'ue', 'letters': /[\u00FC]/g},
            {'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g},
            {'base': 'vy', 'letters': /[\uA761]/g},
            {'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g},
            {'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g},
            {'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g},
            {'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g}
        ];

        let permalink = input;
        for (let i = 0; i < diacriticsMap.length; i++) {
            permalink = permalink.replace(diacriticsMap[i].letters, diacriticsMap[i].base);
        }

        return permalink;
    },

    generateSlugByTitle: function (slug, title) {
        if (!title.length || !slug.length) {
            return false;
        }

        let generatedSlug = general_js.generateSlug(title.val());

        slug.val(generatedSlug);
    },

    generateSlugByTitleEventListener: function () {
        let $title = $('#title');
        let $slug = $('#slug');

        $('#app').on('click', '.generate-slug-button', function () {
            general_js.generateSlugByTitle($slug, $title);
        });
    },

    lazyItems: function () {
        window.lazyItem = null;

        window.lazyItemRegister = function () {
            if (lazyItem) {
                lazyItem.destroy();
            }

            window.lazyItem = $(document).find('.lazy').lazy({
                chainable: false,
                bind: "event",
                scrollDirection: 'vertical',
                effect: 'fadeIn',
                visibleOnly: true,
                afterLoad: function (element) {
                    element.removeClass('lazy');
                }
            });
        };

        window.lazyItemRegister();
    },

    disableTabAnchorJump: function () {
        $('#app').on('click', '.nav-tabs li a', function (e) {
            e.preventDefault();
            $(this).tab('show');
        });
    },

    hexStrToArr: function (hex) {
        let bytes = [];

        for (let c = 0; c < hex.length; c += 2) {
            bytes.push(parseInt(hex.substr(c, 2), 16));
        }
        return bytes;
    },

    initThemeSwitch: function() {
        $('#dark-theme').on('click', function(e) {
            e.preventDefault();
            let $that = $(this);
            let $body = $('body');

            $.ajaxSetup({headers: {'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content}});

            $.ajax({
                type: "POST",
                url: window.MyApp.routes['space.settings.save-persistent'],
                data: {key: 'space_theme', value: 'dark'},
                accepts: {
                    text: "application/json"
                },
                success: function(response) {
                    $that.hide();
                    $body.removeClass('c-light-theme');
                    $body.removeClass('c-dark-theme');
                    $body.addClass('c-dark-theme');
                    $('#light-theme').show();
                },
                error: function(xhr, status, error) {

                }
            });
        });

        $('#light-theme').on('click', function(e) {
            e.preventDefault();
            let $that = $(this);
            let $body = $('body');

            $.ajaxSetup({headers: {'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content}});

            $.ajax({
                type: "POST",
                url: window.MyApp.routes['space.settings.save-persistent'],
                data: {key: 'space_theme', value: 'light'},
                accepts: {
                    text: "application/json"
                },
                success: function(response) {
                    $that.hide();
                    $body.removeClass('c-light-theme');
                    $body.removeClass('c-dark-theme');
                    $body.addClass('c-light-theme');
                    $('#dark-theme').show();
                },
                error: function(xhr, status, error) {

                }
            });
        });
    },

    bugButton: function()
    {
        $('.bug-button').on('click', function(e) {
           e.preventDefault();
           let modal = $('#bugModal');

           let browserData = window.MyApp.helpers['getBrowser']();
           let osData = window.MyApp.helpers['getOs']();
           modal.find('#browser_version').val(browserData.version);
           modal.find('#browser_type').val(browserData.browser);
           modal.find('#os_type').val(osData);

           modal.modal();

            modal.on('shown.coreui.modal', function () {
              $('body').find('.select2-modal').select2({});
            });
        });

        let modal = $('#bugModal');

        window.FormValidator.init('#send-bug-form', {
            successCallback: function (data, formData) {
                $(':input','#send-bug-form')
                    .not(':button, :submit, :reset, :hidden')
                    .val('')
                    .removeAttr('checked')
                    .removeAttr('selected');

                $('#send-bug-form').trigger("reset");
                $('#send-bug-form')[0].reset();
                $('#request_type').val('bug').trigger('change');

                modal.modal('hide');
            }
        });
    },

    getBrowser: function() {
        let BrowserDetect = {
            init: function(userAgent, appVersion) {
                this.browser = this.searchString(this.dataBrowser) || "Other";
                this.version = this.searchVersion(userAgent) || this.searchVersion(appVersion) || "Other";
                this.OS = this.searchString(this.dataOS) || "Other";

                return {
                    browser: this.browser,
                    version: this.version,
                    os: this.OS
                }
            },
            searchString: function(data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;
                    this.versionSearchString = data[i].versionSearch || data[i].identity;
                    if (dataString) {
                        if (dataString.indexOf(data[i].subString) != -1) {
                            return data[i].identity;
                        }
                    } else if (dataProp) {
                        return data[i].identity;
                    }
                }
            },
            searchVersion: function(dataString) {
                var index = dataString.indexOf(this.versionSearchString);
                if (index == -1) return;
                return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
            },
            dataBrowser: [{
                string: navigator.userAgent,
                subString: "Chrome",
                identity: "Chrome"
            }, {
                string: navigator.userAgent,
                subString: "OmniWeb",
                versionSearch: "OmniWeb/",
                identity: "OmniWeb"
            }, {
                string: navigator.vendor,
                subString: "Apple",
                identity: "Safari",
                versionSearch: "Version"
            }, {
                prop: window.opera,
                identity: "Opera",
                versionSearch: "Version"
            }, {
                string: navigator.vendor,
                subString: "iCab",
                identity: "iCab"
            }, {
                string: navigator.vendor,
                subString: "KDE",
                identity: "Konqueror"
            }, {
                string: navigator.userAgent,
                subString: "Firefox",
                identity: "Firefox"
            }, {
                string: navigator.vendor,
                subString: "Camino",
                identity: "Camino"
            }, { // for newer Netscapes (6+)
                string: navigator.userAgent,
                subString: "Netscape",
                identity: "Netscape"
            }, {
                string: navigator.userAgent,
                subString: "MSIE",
                identity: "Explorer",
                versionSearch: "MSIE"
            }, {
                string: navigator.userAgent,
                subString: "Trident",
                identity: "Explorer",
                versionSearch: "rv"
            }, {
                string: navigator.userAgent,
                subString: "Edge",
                identity: "Edge"
            }, {
                string: navigator.userAgent,
                subString: "Gecko",
                identity: "Mozilla",
                versionSearch: "rv"
            }, { // for older Netscapes (4-)
                string: navigator.userAgent,
                subString: "Mozilla",
                identity: "Netscape",
                versionSearch: "Mozilla"
            }],
            dataOS: [{
                string: navigator.platform,
                subString: "Win",
                identity: "Windows"
            }, {
                string: navigator.platform,
                subString: "Mac",
                identity: "Mac"
            }, {
                string: navigator.userAgent,
                subString: "iPhone",
                identity: "iPhone/iPod"
            }, {
                string: navigator.platform,
                subString: "Linux",
                identity: "Linux"
            }]
        };

        return BrowserDetect.init(navigator.userAgent, navigator.appVersion);
    },

    getOs: function() {
        let userAgent = window.navigator.userAgent,
            platform = window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            os = null;

        if (macosPlatforms.indexOf(platform) !== -1) {
            os = 'macOS';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            os = 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = 'Windows';
        } else if (/Android/.test(userAgent)) {
            os = 'Android';
        } else if (!os && /Linux/.test(platform)) {
            os = 'Linux';
        }

        return os;
    },

    formatMAC: function(elem) {
        var cleave = new Cleave(elem, {
            delimiter: ':',
            blocks: [2, 2, 2, 2, 2, 2],
            uppercase: true
        });
    },

    formatVoucher: function(elem) {

        if( $(elem).length === 0 )
        {
            return;
        }

        var cleave = new Cleave(elem, {
            delimiter: '-',
            blocks: [4, 4, 4],
            uppercase: true
        });
    },

    resetDataTableButton: function() {
        $('.resetTable').on('click', function(e) {
            e.preventDefault();
            let $that = $(this);

            Prompter.init({
                title: MyApp.getTrans('general.reset_table_confirm_title'),
                content: '',
            }, function() {
                window.MyApp.helpers.showLoader();

                let type = $.trim($that.attr('data-type'));

                $.ajaxSetup({headers: {'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content}});

                var request = $.ajax({
                    type: 'post',
                    dataType: 'json',
                    url: window.MyApp.routes['space.datatable.reset-state'],
                    data: {type:type }
                });

                request.done(function (response) {
                    window.Notifier.success(MyApp.getTrans('general.reset_table_confirm_success'), {timeout: 8000});

                    setTimeout(function() {
                        location.reload();
                    }, 200);

                    window.MyApp.helpers.hideLoader();
                });

                request.fail(function (jqXHR, textStatus, error) {
                    let errors = jqXHR.responseJSON;

                    if (errors.hasOwnProperty('error')) {
                        window.Notifier.error(errors.error);
                    }

                    window.MyApp.helpers.hideLoader();
                });
            });
        });
    },
    initDatepicker: function(el) {
        let weekdays = [];
        for (let d = 7; d < 14; d++) {
            weekdays.push((new Date(new Date().getFullYear(), 10, d)).toLocaleString([$('html').attr('lang')], {weekday: "long"}));
        }

        let months = [];
        for (let m = 0; m < 12; m++) {
            months.push((new Date(new Date().getFullYear(), m, 1)).toLocaleString([$('html').attr('lang')], {month: "long"}));
        }

        return MCDatepicker.create({
            customWeekDays: weekdays,
            customMonths: months,
            closeOnBlur: true,
            dateFormat: 'yyyy-mm-dd',
            el: el,
            autoClose: true
        });
    },
    initAlertTimePicker: function(el)
    {
        let weekdays = [];
        for (let d = 7; d < 14; d++) {
            weekdays.push((new Date(new Date().getFullYear(), 10, d)).toLocaleString([$('html').attr('lang')], {weekday: "long"}));
        }

        let months = [];
        for (let m = 0; m < 12; m++) {
            months.push((new Date(new Date().getFullYear(), m, 1)).toLocaleString([$('html').attr('lang')], {month: "long"}));
        }

        let picker = MCDatepicker.create({
            customWeekDays: weekdays,
            customMonths: months,
            dateFormat: 'dd.mm.yyyy',
            el: el,
            allowedYears: [new Date().getFullYear()]
        });

        return picker;
    },
    hntRateChanger: function(e) {

        let isNaN = function(value) {
            let n = Number(value);
            return n !== n;
        }

        $(document).on('change keyup', '.hnt_amount', function() {
            let $that = $(this);
            let hntAmount = $that.val();
            let rateElem = $that.parents('.widget-item').find('.rate-value');
            let rateRawValue = rateElem.attr('data-rate');
            let currency = rateElem.attr('data-currency');
            let finalValue = hntAmount * rateRawValue;

            finalValue = ((finalValue * 1000) / 1000).toFixed(4);

            if(isNaN(finalValue))
            {
                return 0;
            }

            rateElem.text(finalValue+' '+currency);
        });
    },

    markNotificationAsRead: function() {
        $(document).on('click', '.close-notification', function(e) {
            e.preventDefault();
            let $that = $(this);
            let notificationId = $that.attr('data-id');

            $.ajaxSetup({headers: {'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content}});

            let request = $.ajax({
                type: 'post',
                dataType: 'json',
                url: window.MyApp.routes['space.notification.mark-as-read'],
                data: {id: notificationId}
            });

            request.done(function (response) {
                if (response.success) {
                    $that.parents('.notification-bar').slideUp();
                }
            });

            request.fail(function (jqXHR, textStatus, error) {
                //
            });

        });
    },
    initSelectEmailTags: function()
    {
        let RE_EMAIL = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

        $(document).find(".select2Tags").select2({
            tags: true,
            formatNoMatches: MyApp.getTrans('general.no_entries_found'),
            escapeMarkup: function (markup) {
                return markup;
            },
            language: {
                noResults: function (params) {
                    return MyApp.getTrans('general.no_entries_found');
                }
            },
            tokenSeparators: [',', ' '],
            createTag: function (params) {
                var term = $.trim(params.term);

                if (term === '') {
                    return null;
                }

                if (params.term.indexOf('@') === -1) {
                    return null;
                }

                if (RE_EMAIL.test(term) === false)
                {
                    return null;
                }

                return {
                    id: term,
                    text: term,
                    newTag: true
                }
            }
        });
    },
}

jQuery.fn.putCursorAtEnd = function() {
    return this.each(function() {
        $(this).focus()
        // If this function exists...
        if (this.setSelectionRange) {
            // ... then use it (Doesn't work in IE)
            // Double the length because Opera is inconsistent about whether a carriage return is one character or two. Sigh.
            var len = $(this).val().length * 2;
            this.setSelectionRange(len, len);
        } else {
            // ... otherwise replace the contents with itself
            // (Doesn't work in Google Chrome)
            $(this).val($(this).val());
        }
        // Scroll to the bottom, in case we're in a tall textarea
        // (Necessary for Firefox and Google Chrome)
        this.scrollTop = 999999;
    });
};

function updatePriceCard($card, currentSlots) {
    $card.find('.slots-count').text(currentSlots);

    let $shellyElementCount = $card.find('.shelly-element-count');
    let $virtualElementCount = $card.find('.virtual-element-count');
    let $httpElementCount = $card.find('.http-element-count');
    let $narrowbandElementCount = $card.find('.narrowband-element-count');
    let $loraElementCount = $card.find('.lora-count');
    let $minerCount = $card.find('.miner-count');
    let $price = $card.find('.amount');

    $shellyElementCount.text(currentSlots / MyApp.constants.usage.SHELLY_ELEMENT);
    $virtualElementCount.text(currentSlots / MyApp.constants.usage.VIRTUAL_ELEMENT);
    $httpElementCount.text(currentSlots / MyApp.constants.usage.HTTP_ELEMENT);
    $narrowbandElementCount.text(currentSlots / MyApp.constants.usage.NARROWBAND_ELEMENT);
    $loraElementCount.text(currentSlots / MyApp.constants.usage.LORA_ELEMENT);
    $minerCount.text(currentSlots / MyApp.constants.usage.MINER);

    let count = parseInt($card.attr('data-position-counter'));
    let totalNet = 8.40 * count;
    let totalPriceNet = Math.round((totalNet + Number.EPSILON) * 100) / 100

    let res = totalNet * 1.19;
    res = res.toFixed(2);
    res = res.replace('.', ',');

    $price.text(res);
}

window.MyApp.helpers = {};
window.MyApp.helpers['showLoader'] = general_js.showLoader;
window.MyApp.helpers['hideLoader'] = general_js.hideLoader;
window.MyApp.helpers['flashAlert'] = general_js.flashAlert;
window.MyApp.helpers['redrawDatatableToFullwidth'] = general_js.redrawDatatableToFullwidth;
window.MyApp.helpers['generateSlug'] = general_js.generateSlug;
window.MyApp.helpers['customAjaxForm'] = general_js.customAjaxForm;
window.MyApp.helpers['hexStrToArr'] = general_js.hexStrToArr;
window.MyApp.helpers['getOs'] = general_js.getOs;
window.MyApp.helpers['getBrowser'] = general_js.getBrowser;
window.MyApp.helpers['cookieConsent'] = general_js.cookieConsent;
window.MyApp.helpers['getCookie'] = general_js.getCookie;
window.MyApp.helpers['eraseCookie'] = general_js.eraseCookie;
window.MyApp.helpers['setCookie'] = general_js.setCookie;
window.MyApp.helpers['formatMAC'] = general_js.formatMAC;
window.MyApp.helpers['formatVoucher'] = general_js.formatVoucher;
window.MyApp.helpers['initDatepicker'] = general_js.initDatepicker;
window.MyApp.helpers['initAlertTimePicker'] = general_js.initAlertTimePicker;
window.MyApp.helpers['isNumeric'] = isNumeric;
window.MyApp.helpers['processWidgetConfig'] = processWidgetConfig;
window.MyApp.helpers['updatePriceCard'] = updatePriceCard;
window.MyApp.helpers['createDynamicLabelDropDown'] = general_js.createDynamicLabelDropDown;
window.MyApp.helpers['initSelectEmailTags'] = general_js.initSelectEmailTags;

function updateAllPriceCards() {
    $('.pricingTable:not(.ignoreMe)').each(function() {
        updatePriceCard($(this), parseInt($(this).attr('data-position-counter')) * 100)
    });
}

$(document).ready(function () {

    $('.ip-link-parent input').on('keyup paste change', function() {
        let $that = $(this);
        let $ipLinkWrapper = $that.parents('.form-group').find('.ip-link-wrapper');

        if($that.val() !== '' && $that.val() !== ' ') {
            $ipLinkWrapper.show();
        }
        else {
            $ipLinkWrapper.hide();
        }

        $that.parents('.form-group').find('.ip-link-text').text($that.val());
        $that.parents('.form-group').find('.ip-link-anchor').attr('href', 'http://'+$that.val());
    });

    $('.title-input').on('keyup paste change', function() {
        let $that = $(this);
        let $titlePlaceholder = $('.title-placeholder');

        $titlePlaceholder.text($that.val());
    });

    $(document).on("mousemove",function(e){
        if ( $(e.target).closest(".chart_wrapper").length == 0 ){
            $("#tooltip").hide();
        }
    });

    $.fn.modal.Constructor.prototype.enforceFocus = function() {};

    $(document).on('change', '.datatable_label', function(e) {
        window.MyApp.helpers.showLoader();

        let $that = $(this);
        let val = $that.find('option:selected').attr('data-url');
        let currentUrl = window.location.href;

        let queryStringIndex = currentUrl.indexOf('?');

        if (queryStringIndex !== -1) {
            currentUrl = currentUrl.substring(0, queryStringIndex);
        }

        let url = currentUrl+''+val;

        if( val === '' ) {
            url =  url.split('?')[0];
        }

        window.location = url;
    });

    $(document).on('click', '.slot-arrow', function(e) {
        e.preventDefault();
        let $that = $(this);
        let $card = $that.parents('.pricingTable');
        let type = $that.hasClass('increase-slots') ? 'increase' : 'decrease';
        let currentSlots = parseInt($card.find('.slots-count').text());

        if(type === 'increase') {
            $card.attr('data-position-counter', parseInt($card.attr('data-position-counter')) + 1);
        }

        if(type === 'decrease') {
            if (parseInt($card.attr('data-position-counter')) > 1) {
                $card.attr('data-position-counter', parseInt($card.attr('data-position-counter')) - 1);
            }
        }

        currentSlots = parseInt($card.attr('data-position-counter')) * 100;

        updatePriceCard($card, currentSlots);
    });

    updateAllPriceCards()


    $(document).on('keyup paste', '.check-decimal-format', function() {
        var inputValue = $(this).val();
        var validChars = '0123456789.-';

        // Remove any invalid characters
        inputValue = inputValue.split('').filter(function(char) {
            return validChars.indexOf(char) !== -1;
        }).join('');

        // Ensure that there are no multiple occurrences of '-' or '.'
        if (inputValue.match(/-/g) !== null && inputValue.match(/-/g).length > 1) {
            inputValue = inputValue.slice(0, -1);
        }
        if (inputValue.match(/\./g) !== null && inputValue.match(/\./g).length > 1) {
            inputValue = inputValue.slice(0, -1);
        }

        // Ensure that the decimal separator is '.'
        inputValue = inputValue.replace(/,/g, '.');

        // Disallow dots as the first character
        if (inputValue.charAt(0) === '.') {
            inputValue = inputValue.slice(1);
        }

        // Remove any illegal characters
        inputValue = inputValue.replace(/[^\d.-]/g, '');

        // Update the input field value
        $(this).val(inputValue);
    });

    $(window).on('orientationchange', function() {
        console.log('Orientation was changed...');
        $(window).trigger('resize');
    });



    general_js.markNotificationAsRead();
    general_js.hntRateChanger();
    window.LightTableFilter.init();
    //general_js.aosInit();
    general_js.bugButton();
    general_js.resetDataTableButton();
    general_js.initThemeSwitch();
    general_js.flashAlert();
    //general_js.checkRowDelete();
    general_js.sidebarToggleSetting();
    general_js.sidebarMinimizerSetting();
    general_js.asideToggleSetting();
    general_js.initSiteSettings();
    general_js.ajaxForm();
    general_js.select2();
    general_js.confirmAction();
    general_js.allowNumericWithDecimal();
    general_js.allowNumericWithoutDecimal();
    general_js.tooltip();
    general_js.tablesorter();
    //general_js.disableLinks();
    general_js.matchHeightInit();
    general_js.tabJumpToTop();
    //general_js.resizeSelect2();
    //general_js.mainNavigation();
    //general_js.cardActions();
    //general_js.disableMovingToTop();
    general_js.tabHashNavigation();
    general_js.inputSlugListener();
    general_js.preSelectTab();
    general_js.lazyItems();
    general_js.disableTabAnchorJump();
    general_js.generateSlugByTitleEventListener();
    general_js.customToggleSections();
    //general_js.resizeBroadcast();
    //$(window).on('resize', general_js.resizeSelect2);
});
